import {useForm} from 'react-hook-form';
import {joiResolver} from '@hookform/resolvers/joi';
import joiMessages from 'components/forms/locale/validation';
import Joi from 'joi';

/**
 * Hoist a react-hook-form
 */
export default function useNonPersistentFormMethods({
    initialValues,
    schema,
    ...props
}) {
    const methods = useForm({
        defaultValues: initialValues,
        mode: 'onTouched',
        resolver: joiResolver(
            Joi.object(schema).messages(joiMessages).unknown(true)
        ),
        ...props,
    });

    return methods;
}
